import { createApi } from '@reduxjs/toolkit/query/react';
import { rtkBaseQuery } from '../helpers/rtkquery';

export const permissionApi = createApi({
  reducerPath: 'permissionApi',
  baseQuery: rtkBaseQuery('/auth/Permission'),
  tagTypes: ['Permissions'],
  endpoints: (builder) => ({
    getAll: builder.query({
      query: () => '/GetAll',
      providesTags: ['Permissions'],
    }),
    getAsTreeViewPermissions: builder.query({
      query: () => '/GetAsTreeView',
      providesTags: ['Permissions'],
    }),
    insertPermission: builder.mutation({
      query: (body) => ({
        url: '/Insert',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Permissions'],
    }),
    userAccess: builder.mutation({
      query: (body) => ({
        url: '/UserAccess',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Permissions'],
    }),
    connectRoleToPermissions: builder.mutation({
      query: (body) => ({
        url: '/Create',
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Permissions'],
    }),
    permissionGetById: builder.query({
      query: (id) => `/GetById/${id}`,
      providesTags: (result, error, id) => [{ type: 'Permission', id }],
    }),
    updateRolePermission: builder.mutation({
      query: ({ id, body }) => ({
        url: `/Update/${id}`,
        method: 'PUT',
        body,
      }),
    }),
  }),
});

export const {
  useGetAllQuery,
  useGetAsTreeViewPermissionsQuery,
  useInsertPermissionMutation,
  useUserAccessMutation,
  useConnectRoleToPermissionsMutation,
  useLazyPermissionGetByIdQuery,
  useUpdateRolePermissionMutation,
} = permissionApi;
